import script from "./serviceBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./serviceBtn.vue?vue&type=script&lang=ts&setup=true"

import "./serviceBtn.vue?vue&type=style&index=0&id=3cec5eb3&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cec5eb3"]])

export default __exports__